import type { Action, StoreActionApi } from 'react-sweet-state';
import { fg } from '@atlassian/jira-feature-gating';
import type { State, X2CImportValidationError } from '../../../../common/types';

export type SetMappingStateValidationErrorAction = (
	validationError: X2CImportValidationError,
) => Action<State, void, void>;

export const setMappingStateValidationError =
	(validationError: X2CImportValidationError) =>
	({ setState, getState }: StoreActionApi<State>) => {
		const state = getState();
		if (!state.mappingState) {
			return;
		}

		if (fg('enable-x2c-standardised-flow')) {
			setState({
				mappingState: {
					...state.mappingState,
					validationError,
					errorsFilter: Object.keys(validationError.columnErrors),
				},
			});
			return;
		}

		const columnOrder = [...state.mappingState.columnOrder];
		columnOrder.sort((a, b) => {
			if (validationError.columnErrors[a] && validationError.columnErrors[b]) {
				return 0;
			}
			if (validationError.columnErrors[a]) {
				return -1;
			}
			return 0;
		});

		setState({
			mappingState: {
				...state.mappingState,
				validationError,
				columnOrder,
			},
		});
	};
